<section class="about-v2">
    <div class="container">
        <div class="block">
            <div class="text">
                <h1 [style.viewTransitionName]="'title'">The Heart Behind WondrVoices</h1>
                <div class="text-copy">
                    <p>WondrVoices began with a simple idea: even small messages can carry great meaning.</p>
                    <p>Through anonymous acts of kindness and creative expression, we help people facing illness feel less alone and remind the world that compassion still connects us.</p>
                </div>
            </div>
            <div class="image-wrap">
                <img src="assets/img/about/1.webp" alt="Art supplies on a table" />
                <div class="decor decor-purple"></div>
            </div>
        </div>

        <div class="block reverse">
            <div class="image-wrap">
                <img src="assets/img/about/2.webp" alt="Community members creating cards together" />
                <div class="decor decor-orange"></div>
            </div>
            <div class="text">
                <h2>Who We Are</h2>
                <div class="text-copy">
                    <p>It began with something simple: people gathering to create and send heartfelt cards to those facing hard times, each one a quiet reminder that someone cares.</p>
                    <p>Those early cards carried simple but powerful messages: it is okay to not be okay, you are not alone, and there is still hope.</p>
                    <p>What began as a local initiative has evolved into a movement, giving voice to the whole cancer experience through empathy, creativity, and connection.</p>
                    <p>WondrVoices was created through the work of <a href="https://wondrlink.org/" target="_blank" rel="noopener noreferrer">the WondrLink Foundation, a 501(c)(3) nonprofit</a> that helps patients access life-saving treatments. While WondrLink focuses on medical pathways, WondrVoices offers something just as vital: emotional connection when it is needed most.</p>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="text">
                <h2>Why Your Voice Matters</h2>
                <div class="text-copy">
                    <p>A cancer diagnosis is more than a medical event. It can bring fear, confusion, and a crushing silence. For loved ones, it can bring heartbreak and uncertainty about what to say or how to help.</p>
                    <p>WondrVoices helps bridge that silence. With a single card, drawing, or message, anyone can offer comfort and presence.</p>
                    <p>In doing so, we are not only supporting patients. We are showing our communities how to respond with empathy, creativity, and care.</p>
                    <p>Hearing the word cancer can feel like the end, but it should never mean the end of hope.</p>
                </div>
            </div>
            <div class="image-wrap">
                <img src="assets/img/about/3.webp" alt="People painting together" />
                <div class="decor decor-yellow"></div>
            </div>
        </div>

        <div class="block reverse">
            <div class="image-wrap">
                <img src="assets/img/about/4.webp" alt="Paint brushes and artwork details" />
                <div class="decor decor-green"></div>
            </div>
            <div class="text">
                <h2>What We Mean by "Voice"</h2>
                <div class="text-copy">
                    <p>We believe in the power of voice because voice is more than words. It is expression, intention, and connection.</p>
                    <p><strong>Voice about:</strong> isolation, joy, fear, hope, love, grief, and endurance.</p>
                    <p><strong>Voice from:</strong> a peer, a parent, a survivor, a child, or a stranger who understands.</p>
                    <p><strong>Voice for:</strong> connection, navigation, support, and redefining what is possible.</p>
                    <p>Each voice is unique. Each one carries meaning. When shared, each becomes part of something bigger.</p>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="text">
                <h2>What We Do</h2>
                <div class="text-copy">
                    <p>WondrVoices exists to give voice to every part of the cancer experience.</p>
                    <p>It is a way to support, be heard, connect, advocate, and remind someone that they still matter.</p>
                    <p><strong>One card at a time. One voice at a time. One life at a time.</strong></p>
                </div>
            </div>
            <div class="image-wrap">
                <img src="assets/img/about/5.webp" alt="Handmade artwork in progress" />
                <div class="decor decor-yellow"></div>
            </div>
        </div>
    </div>
</section>
